/* Pielnora PDP v3 (Maelys-modeled product page) - theme interactions.
   Header/drawer JS lives inline in the v2-header section (shared sitewide).
   Commerce model (Oct 2026): once = this template's bundle product variant;
   sub / year = BOTH tube variants with the Appstle selling plan (both SKUs on
   the order, per Verde). Wired by liquid data-attributes on the .plan pills. */
(function () {
  'use strict';

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-pln-orig]').forEach(function (el) {
      el.innerHTML = el.dataset.plnOrig;
    });
  });

  // gallery
  var main = document.getElementById('galMain');
  var thumbs = document.querySelectorAll('#galThumbs .gal__t');
  if (main && thumbs.length) {
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-on'); });
        t.classList.add('is-on');
        if (t.dataset.video) {
          main.innerHTML = '<video src="' + t.dataset.video + '" poster="' + (t.dataset.poster || '') + '" autoplay muted loop playsinline></video>';
        } else {
          main.innerHTML = '<img src="' + t.dataset.img + '" alt="">';
        }
      });
    });
  }

  // plan selector + add to cart
  var plansBox = document.getElementById('plans');
  var cta = document.getElementById('ctaBtn');
  var ctaPrice = document.getElementById('ctaPrice');
  if (plansBox && cta) {
    var plans = plansBox.querySelectorAll('.plan');
    var select = function (p) {
      plans.forEach(function (x) { x.classList.remove('is-on'); });
      p.classList.add('is-on');
      if (ctaPrice && p.dataset.price) ctaPrice.textContent = p.dataset.price;
    };
    plans.forEach(function (p) {
      p.addEventListener('click', function () { select(p); });
    });

    // deep links from the rest of the site: #plan-sub | #plan-once | #plan-year
    var m = location.hash.match(/^#plan-(year|sub|once)(-scrub)?$/);
    if (m) {
      var target = plansBox.querySelector('.plan[data-plan="' + m[1] + '"]');
      if (target) select(target);
    }

    cta.addEventListener('click', function (e) {
      e.preventDefault();
      var p = plansBox.querySelector('.plan.is-on') || plans[0];
      if (!p || !p.dataset.variant) {
        cta.textContent = 'Set the product handles in theme settings to enable checkout';
        return;
      }
      // sub/year must carry a selling plan - never fall through to a full-price add
      if (p.dataset.requiresPlan && !p.dataset.sellingPlan) {
        cta.textContent = 'Subscription plan not found - check Appstle selling plans';
        return;
      }
      var items = [{ id: +p.dataset.variant, quantity: 1 }];
      if (p.dataset.sellingPlan) items[0].selling_plan = +p.dataset.sellingPlan;
      if (p.dataset.variant2) {
        var second = { id: +p.dataset.variant2, quantity: 1 };
        if (p.dataset.sellingPlan) second.selling_plan = +p.dataset.sellingPlan;
        items.push(second);
      }
      cta.dataset.plnOrig = cta.innerHTML;
      cta.textContent = 'Adding to bag…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) {
          return r.json().then(function (err) {
            throw new Error((err && (err.description || err.message)) || 'Something went wrong - try again');
          }, function () {
            throw new Error('Something went wrong - try again (' + r.status + ')');
          });
        }
        window.location.href = cta.dataset.cartUrl || '/cart';
      }).catch(function (err) {
        cta.textContent = (err && err.message) || 'Something went wrong - try again';
        if (window.console) console.error('[pielnora] cart add failed:', err, items);
      });
    });
  }

  // singles cross-sell: one-time add of a single tube
  document.querySelectorAll('.xsell__add[data-single]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.preventDefault();
      var vid = b.dataset.variant;
      if (!vid) { b.textContent = 'Set product handle in theme settings'; return; }
      b.dataset.plnOrig = b.innerHTML;
      b.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: +vid, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) {
          return r.json().then(function (err) {
            throw new Error((err && (err.description || err.message)) || 'Something went wrong - try again');
          }, function () { throw new Error('Something went wrong - try again'); });
        }
        window.location.href = b.dataset.cartUrl || '/cart';
      }).catch(function (err) {
        b.textContent = (err && err.message) || 'Try again';
      });
    });
  });

  // compare carousel (held from launch; guarded so its absence is fine)
  var slides = document.querySelectorAll('#cmpTrack img');
  var prevBtn = document.getElementById('cmpPrev');
  var nextBtn = document.getElementById('cmpNext');
  if (slides.length && prevBtn && nextBtn) {
    var dots = document.querySelectorAll('#cmpDots i');
    var idx = 0;
    var show = function (n) {
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-on', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-on', i === idx); });
    };
    prevBtn.addEventListener('click', function () { show(idx - 1); });
    nextBtn.addEventListener('click', function () { show(idx + 1); });
  }

  // reviews: search / rating filter / sort / pagination / helpful votes
  var revSec = document.getElementById('reviews');
  var pagesEl = document.getElementById('revPages');
  var allRows = revSec ? Array.prototype.slice.call(revSec.querySelectorAll('.rrow')) : [];
  if (allRows.length && pagesEl) {
    var PER = 10;
    var cur = 0;
    var view = allRows.slice();
    var qEl = document.getElementById('revSearch');
    var ratingEl = document.getElementById('revRating');
    var sortEl = document.getElementById('revSort');

    var render = function (scroll) {
      allRows.forEach(function (r) { r.style.display = 'none'; });
      view.forEach(function (r, i) {
        r.style.display = (i >= cur * PER && i < (cur + 1) * PER) ? '' : 'none';
      });
      var pages = Math.ceil(view.length / PER);
      var empty = revSec.querySelector('.rev__empty-note');
      if (!view.length) {
        if (!empty) {
          empty = document.createElement('p');
          empty.className = 'rev__empty-note';
          empty.textContent = 'No reviews match your search.';
          pagesEl.parentNode.insertBefore(empty, pagesEl);
        }
      } else if (empty) { empty.remove(); }
      if (pages < 2) { pagesEl.innerHTML = ''; }
      else {
        var html = '<button class="rp" data-p="prev" ' + (cur === 0 ? 'disabled' : '') + '>&#8249;</button>';
        for (var p = 0; p < pages; p++) {
          html += '<button class="rp' + (p === cur ? ' is-on' : '') + '" data-p="' + p + '">' + (p + 1) + '</button>';
        }
        html += '<button class="rp" data-p="next" ' + (cur === pages - 1 ? 'disabled' : '') + '>&#8250;</button>';
        pagesEl.innerHTML = html;
      }
      if (scroll) revSec.scrollIntoView({ behavior: 'smooth' });
    };

    var apply = function () {
      var text = (qEl && qEl.value || '').toLowerCase().trim();
      view = allRows.filter(function (r) {
        if (ratingEl && ratingEl.value && r.dataset.rating !== ratingEl.value) return false;
        if (text && r.textContent.toLowerCase().indexOf(text) === -1) return false;
        return true;
      });
      var mode = sortEl ? sortEl.value : 'recent';
      if (mode === 'recent') view.sort(function (a, b) { return (b.dataset.date || '').localeCompare(a.dataset.date || ''); });
      else if (mode === 'helpful') view.sort(function (a, b) { return (+b.dataset.helpful || 0) - (+a.dataset.helpful || 0); });
      else if (mode === 'high') view.sort(function (a, b) { return (+b.dataset.rating || 0) - (+a.dataset.rating || 0); });
      else if (mode === 'low') view.sort(function (a, b) { return (+a.dataset.rating || 0) - (+b.dataset.rating || 0); });
      view.forEach(function (r) { pagesEl.parentNode.insertBefore(r, pagesEl); });
      cur = 0;
      render(false);
    };

    if (qEl) qEl.addEventListener('input', apply);
    if (ratingEl) ratingEl.addEventListener('change', apply);
    if (sortEl) sortEl.addEventListener('change', apply);

    pagesEl.addEventListener('click', function (e) {
      var b = e.target.closest('.rp');
      if (!b || b.disabled) return;
      var pages = Math.ceil(view.length / PER);
      var p = b.dataset.p;
      if (p === 'prev') cur = Math.max(0, cur - 1);
      else if (p === 'next') cur = Math.min(pages - 1, cur + 1);
      else cur = parseInt(p, 10);
      render(true);
    });
    apply();

    // helpful votes -> the vote worker (theme setting reviews_vote_url); one vote
    // per review per browser (localStorage). No endpoint configured -> the vote
    // still registers locally in this browser (Oct 30 per Srdjan), it just never
    // reaches the metaobject counts until the worker URL is set.
    var voteUrl = revSec.dataset.voteUrl;
    var voted = {};
    try { voted = JSON.parse(localStorage.getItem('pln-rev-votes') || '{}'); } catch (e) {}
    revSec.querySelectorAll('.rrow__vote').forEach(function (b) {
      var row = b.closest('.rrow');
      var id = row && row.dataset.id;
      if (!id) return;
      if (voted[id]) {
        b.disabled = true;
        if (voted[id] === b.dataset.dir) b.classList.add('is-voted');
        return;
      }
      b.addEventListener('click', function () {
        if (voted[id]) return;
        voted[id] = b.dataset.dir;
        try { localStorage.setItem('pln-rev-votes', JSON.stringify(voted)); } catch (e) {}
        var countEl = b.querySelector('b');
        if (countEl) countEl.textContent = (+countEl.textContent || 0) + 1;
        if (b.dataset.dir === 'up' && row) row.dataset.helpful = (+row.dataset.helpful || 0) + 1;
        b.classList.add('is-voted');
        row.querySelectorAll('.rrow__vote').forEach(function (x) { x.disabled = true; });
        if (voteUrl) {
          fetch(voteUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: id, dir: b.dataset.dir })
          }).catch(function (e) {
            if (window.console) console.error('[pielnora] vote failed:', e);
          });
        }
      });
    });
  }

  // mobile sticky buy bar: appears when the buy-box CTA scrolls above the viewport
  var bb = document.getElementById('pdpBuybar');
  var ctaMain = document.getElementById('ctaBtn');
  if (bb && ctaMain && 'IntersectionObserver' in window) {
    var bbBtn = document.getElementById('bbBtn');
    var bbPrice = document.getElementById('bbPrice');
    var bbPlan = document.getElementById('bbPlan');
    var bbSync = function () {
      var p = document.getElementById('ctaPrice');
      if (p && bbPrice) bbPrice.textContent = p.textContent;
      var on = document.querySelector('.plan.is-on');
      if (on && bbPlan) {
        var name = '';
        on.childNodes.forEach(function (n) { if (n.nodeType === 3) name += n.textContent; });
        var sm = on.querySelector('small');
        bbPlan.textContent = name.trim() + (sm ? ' \u00b7 ' + sm.textContent : '');
      }
    };
    bbSync();
    document.querySelectorAll('.plan').forEach(function (pl) {
      pl.addEventListener('click', function () { setTimeout(bbSync, 0); });
    });
    new IntersectionObserver(function (en) {
      var e = en[0];
      bb.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(ctaMain);
    if (bbBtn) bbBtn.addEventListener('click', function (ev) {
      ev.preventDefault();
      ctaMain.click();
    });
  }

})();

/* ---- video testimonials ---- */
(function(){
  var row = document.getElementById('vtRow');
  if (!row) return;
  var cards = [].slice.call(row.querySelectorAll('.vt__card'));
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var PREVIEW_SECS = 5;
  function toPreview(c){
    var v = c.querySelector('video');
    c.classList.remove('is-playing');
    v.muted = true;
    if (v.currentTime >= PREVIEW_SECS) v.currentTime = 0;
    if (!reduced && c._inView) v.play().catch(function(){});
    else v.pause();
  }
  cards.forEach(function(c){
    var v = c.querySelector('video');
    if (!v) return;
    v.muted = true;
    v.addEventListener('timeupdate', function(){
      if (!c.classList.contains('is-playing') && v.currentTime >= PREVIEW_SECS) v.currentTime = 0;
    });
    c.addEventListener('click', function(){
      if (c.classList.contains('is-playing')){ toPreview(c); return; }
      cards.forEach(function(o){ if (o !== c) toPreview(o); });
      v.muted = false;
      v.currentTime = 0;
      v.play().catch(function(){ v.muted = true; v.play().catch(function(){}); });
      c.classList.add('is-playing');
    });
    v.addEventListener('ended', function(){ v.currentTime = 0; toPreview(c); });
  });
  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        var c = e.target, v = c.querySelector('video');
        c._inView = e.isIntersecting;
        if (c.classList.contains('is-playing')){
          if (!e.isIntersecting) toPreview(c);
          return;
        }
        if (e.isIntersecting && !reduced) v.play().catch(function(){});
        else v.pause();
      });
    }, {threshold: 0.35});
    cards.forEach(function(c){ io.observe(c); });
  }
  var prev = document.getElementById('vtPrev'), next = document.getElementById('vtNext');
  if (prev && next){
    var step = function(){ var c = row.querySelector('.vt__card'); return c ? c.offsetWidth + 10 : 180; };
    var syncBtns = function(){
      var max = row.scrollWidth - row.clientWidth - 4;
      prev.disabled = row.scrollLeft <= 4;
      next.disabled = row.scrollLeft >= max;
    };
    prev.addEventListener('click', function(){ row.scrollBy({left: -step(), behavior: 'smooth'}); });
    next.addEventListener('click', function(){ row.scrollBy({left: step(), behavior: 'smooth'}); });
    row.addEventListener('scroll', syncBtns, {passive: true});
    window.addEventListener('resize', syncBtns);
    syncBtns();
  }
})();
